import React from "react";
import { Switch, Route } from "react-router-dom";

import "./Vehicles.scss";

import VehiclesPage from "./VehiclesPage";
import VehiclePage from "./VehiclePage";
import NewVehiclePage from "./NewVehiclePage";

const VehiclesRouter = () => (
  <Switch>
    <Route path="/fleet/vehicles/new">
      <NewVehiclePage />
    </Route>
    <Route path="/fleet/vehicles/:id">
      <VehiclePage />
    </Route>
    <Route path="/fleet/vehicles">
      <VehiclesPage />
    </Route>
  </Switch>
);

export default VehiclesRouter;
